import React, { useEffect, useRef, useState } from 'react';
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  IconButton,
  ListItemText,
  MenuItem,
  MenuList,
  Toolbar,
  Typography,
} from '@mui/material';
import { ChevronLeft } from '@mui/icons-material';
import { Action, Category, selectActions, selectCategories } from '../../store/buyerSlice';
import { useSelector } from 'react-redux';

const i18n = {
  title: {
    actions: {
      th: 'กิจกรรม',
      en: 'Activities',
      cn: '动作',
    },
    category: {
      th: 'ประเภท',
      en: 'Categories',
      cn: '类型',
    },
  },
};

export interface SearchListProps {
  type: 'actions' | 'category';

  onBackRequest?: () => void;
  onSelected?: (item: Action | Category | null) => void;
}

const SearchList = (props: SearchListProps) => {
  const isMounted = useRef<boolean>(false);
  const actions = useSelector(selectActions);
  const categories = useSelector(selectCategories);
  const [list, setList] = useState<Action[] | Category[] | null>(null);

  useEffect(() => {
    isMounted.current = true;
    if (isMounted.current) {
      if (props.type === 'actions') {
        setList(actions);
      } else if (props.type === 'category') {
        setList(categories);
      }
    }

    return () => {
      isMounted.current = false;
    };
  }, [actions]);

  const handleMenuClicked = (item: Action | Category) => {
    props.onSelected?.(item);
  };

  return (
    <Box
      sx={{
        background: '#f3f3f3',
      }}
      className="w-screen h-screen">
      <AppBar elevation={0}>
        <Toolbar sx={{ px: 0 }}>
          <IconButton
            onClick={() => {
              props.onBackRequest?.();
            }}>
            <ChevronLeft fontSize="large" sx={{ color: '#090909' }} />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ textAlign: 'center' }}>
            {i18n.title[props.type]['th']}
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Container sx={{ paddingY: '15px' }}>
        {list && list.length > 0 && (
          <Box
            sx={{
              bgcolor: 'white',
              width: '100%',
              maxHeight: 'calc(100vh - (32px + 16px + 48px))',
              overflowY: 'auto',
            }}>
            <MenuList sx={{ overflow: 'scroll', background: 'white', padding: '0px' }}>
              {list.map((item, index) => {
                return (
                  <MenuItem
                    key={index}
                    sx={{ borderBottom: '2px solid #f3f3f3' }}
                    onClick={() => handleMenuClicked(item)}>
                    <ListItemText sx={{ fontSize: '22px' }}>{item.nameTH}</ListItemText>
                  </MenuItem>
                );
              })}
            </MenuList>
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default SearchList;
